export default __webpack_public_path__ + "static/IMG_1262-701edaf112aa0f3730c983122fe6ba7e.jpg";